import { Component, OnInit, Input } from '@angular/core';
import { WidgetConfiguration } from '../../../../../interfaces/WidgetInterfaces';

@Component({
  selector: 'app-generic-chart-config',
  template: `<p>
  generic-chart-config works!
</p>
`,
  styles: [``]
})
export class GenericChartConfigComponent implements OnInit {

  @Input() widgetConfig: WidgetConfiguration;

  constructor() { }

  ngOnInit() {
  }

}
